export default {
    'inch-token-item-cross-chain-accordion.network': 'Network',
    'inch-token-item-cross-chain-accordion.networks': 'Networks',
    'inch-token-list.search-empty': 'Token {{name}} not found',
    'inch-token-list.search-empty-description': 'Try changing your search query',
};
//# sourceMappingURL=en.js.map